export default "__VITE_ASSET__2d59ce67__"